export default __webpack_public_path__ + "static/media/bg-image.8061134f.jpg";